<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="BlogArticleListComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BlogArticleListComponent'>
        <img src="static/images/icons/engrenagem.svg"
             class="svg-icon normal-action"
             @click="openPopupChoose"/>
      </options-element-bar>

      <div v-if="checkCondition()">
        <div class="container">
          <div
          v-if="internal_config.theme === 'simple'"
          class="card-container">
            <card-post-simple
              v-for="(article, index) in articles"
              :key="article.id"
              :class="getClasses(index)" :style="getCardStyle(index)"
              :config="internal_config.card.config"
              :styles="internal_config.card.styles"
              :colors="internal_config.card.colors"
              :show="internal_config.card.show"
              :sizes="internal_config.card.sizes"
              :article="article"
            ></card-post-simple>
          </div>
          <div v-if="internal_config.theme === 'clean'">
            <card-clean
              v-for="article in articles"
              :key="article.id"
              class="mt-3"
              :config="internal_config.card.config"
              :styles="internal_config.card.styles"
              :colors="internal_config.card.colors"
              :show="internal_config.card.show"
              :sizes="internal_config.card.sizes"
              :article="article"
            />
          </div>
          <div v-if="internal_config.theme === 'hover'" class="card-container">
            <card-hover
              v-for="(article, index) in articles"
              :key="article.id"
              :class="getClasses(index)" :style="getCardStyle(index)"
              :config="internal_config.card.config"
              :styles="internal_config.card.styles"
              :colors="internal_config.card.colors"
              :show="internal_config.card.show"
              :sizes="internal_config.card.sizes"
              :article="article"
            />
          </div>
          <div v-if="internal_config.theme === 'list'">
            <card-list
              v-for="(article, index) in articles"
              :key="article.id"
              class="mt-3"
              :position="index"
              :config="internal_config.card.config"
              :styles="internal_config.card.styles"
              :colors="internal_config.card.colors"
              :show="internal_config.card.show"
              :sizes="internal_config.card.sizes"
              :article="article"
            />
          </div>
          <div v-if="internal_config.type === 'feed'">
            <div style="display: flex; flex-wrap: wrap; justify-content: center">
              <nav aria-label="Page navigation example">
                <ul class="pagination mt-1">
                  <li  class="page-item"><a class="page-link" :style="`background-color: ${internal_config.card.colors.color_4}; color:  ${internal_config.card.colors.color_5}; border: 1px solid transparent;   margin-right: 2px`" href="#">{{ $t('ct-previous') }}</a></li>
                  <li class="page-item"><a class="page-link" :style="`background-color: ${internal_config.card.colors.color_4}; color:  ${internal_config.card.colors.color_5}; border: 1px solid transparent;  margin-right: 2px`"  href="#">1</a></li>
                  <li class="page-item"><a class="page-link" :style="`background-color: ${internal_config.card.colors.color_4}; color:  ${internal_config.card.colors.color_5}; border: 1px solid transparent;   margin-right: 2px`"  href="#">2</a></li>
                  <li class="page-item"><a class="page-link" :style="`background-color: ${internal_config.card.colors.color_4}; color:  ${internal_config.card.colors.color_5}; border: 1px solid transparent;   margin-right: 2px`"  href="#">3</a></li>
                  <li class="page-item"><a class="page-link" :style="`background-color: ${internal_config.card.colors.color_4}; color:  ${internal_config.card.colors.color_5}; border: 1px solid transparent;   margin-right: 2px`"  href="#">{{ $t('ct-next') }}</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

      </div>
      <div v-else>
        <div style="background-color: white; height: 300px; width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column">
          <h6 class="text-center">{{ $t('ct-no-articles-selected') }}</h6>
          <span>{{ $t('ct-helper-select-valid-filter') }}</span>
        </div>
      </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import elementData from './Model';
import OptionsElementBar from '../../../OptionsElementBar';
import Resources from './Resource';
import _ from 'lodash';

import CardPostSimple from './cards/Simple';
import CardClean from './cards/Clean'
import CardHover from './cards/Hover';
import CardList from './cards/List';

import TestTheme from './cards/Teste';
import { getFilteredNews } from '../../../../../../js/services/editor/blog.js';

export default {
  name: 'BlogArticleListComponent',
  props: ['config', 'id'],
  components: {
    OptionsElementBar,
    Resources,
    CardPostSimple,
    TestTheme,
    CardHover,
    CardClean,
    CardList
  },
  data() {
    return elementData.data();
  },
  methods: {
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    build(config) {
      this.internal_config = _.merge(this.internal_config, config);
    },
    animation() {
      return false;
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    checkCondition() {
      if (this.internal_config.type === 'featured' && this.internal_config.selectedArticle === 0) { return false }
      if (this.internal_config.type === 'group' && this.articles.length === 0) { return false }
      if (this.internal_config.type === 'feed' && this.articles.length === 0) { return false }

      return true;
    },
    getClasses(index) {
      return 'mt-2 mb-1 card-article';
    },
    getCardStyle(index) {
      if (this.internal_config.type === 'featured') { return 'width: 100%' }
      if (this.internal_config.type === 'group') {
        if (this.articles.length === 1) {
          return 'width: 100%';
        }
      }

      function calcSizes(columns) {
        let widthCalculated = parseInt(100 / columns - 1);
        let marginCalculated = (100 - (widthCalculated * columns)) / columns;
        return `width: ${widthCalculated}%; margin-left: ${marginCalculated}%`;
      }

      if (this.internal_config.headline !== 'none') {
        switch (this.internal_config.headline) {
          case '1-100': {
            let result = (index === 0) ? calcSizes(1) : calcSizes(this.internal_config.columns);
            return result;
          }
          case '2-50': {
            let result = (index <= 1) ? calcSizes(2) : calcSizes(this.internal_config.columns);
            return result;
          }
          case '3-33': {
            let result = (index <= 2) ? calcSizes(3) : calcSizes(this.internal_config.columns);
            return result;
          }
          case '4-25': {
            let result = (index <= 3) ? calcSizes(4) : calcSizes(this.internal_config.columns);
            return result;
          }
          case 'last-column': {
            let result = (index === 0) ? `width:  ${100 / this.internal_config.columns - 1}%; margin-left: ${100 - (100 / this.internal_config.columns - 1)}%;` : calcSizes(this.internal_config.columns);
            return result;
          }
        }
      }

      return calcSizes(this.internal_config.columns);
    },
    callbackConfig(data) {
      this.internal_config.card.show = _.clone(data.showOptions);
      this.internal_config.headline = _.clone(data.theme.headline);
      this.internal_config.columns = _.clone(data.theme.columns);
      this.internal_config.theme = _.clone(data.theme.selectedTheme);
      this.internal_config.card.config.dateFormat = _.clone(data.dateFormat);
      this.internal_config.card.config.readMoreText = _.clone(data.readMoreText);

      if (this.internal_config.theme === 'clean' && this.internal_config.card.sizes.thumbnail.width === '0px') {
        this.internal_config.card.sizes.thumbnail.width = '100px';
      }

      if (this.internal_config.type === 'featured') { this.internal_config.selectedArticle = data.selectedArticle }
      if (this.internal_config.type === 'group') { this.internal_config.filters = _.clone(data.filters) }
      if (this.internal_config.type === 'feed') { this.internal_config.filters = _.clone(data.feedFilters) }

      this.getNews();
    },
    openPopupChoose() {
      this.$root.$emit('openBlogSettingsModal', _.clone(this.internal_config), this.$options.name, this.callbackConfig);
    },
    getNews() {
      let vm = this;
      getFilteredNews(this.internal_config)
        .then(({data}) => {
          if (data.success) {
            if (vm.internal_config.type === 'featured') {
              let result = [];
              result.push(data.data);
              vm.articles = result;
            }
            if (vm.internal_config.type === 'group' || vm.internal_config.type === 'feed') {
              vm.articles = data.data;
            }
          } else {
            if (vm.internal_config.type === 'featured') {
              this.internal_config.selectedArticle = 0;
            }
            if (vm.internal_config.type === 'group') {
              vm.articles = [];
            }
          }
        });
    },
    article() {
      return this.internal_config.article;
    },
    style() {
      return `width: ${this.internal_config.width};
               height:  ${this.internal_config.height};
               z-index: ${this.internal_config.zIndex};
               margin: 0 auto;
               padding-top: ${this.internal_config.paddingTop};
               padding-left: ${this.internal_config.paddingLeft};
               padding-right: ${this.internal_config.paddingRight};
               padding-bottom: ${this.internal_config.paddingBottom};
               left:  ${this.internal_config.left};
               top: ${this.internal_config.top}`;
    },
    styleCard() {
      return `background-color: ${this.internal_config.backgroundColor};
      padding: 15px`;
    }
  },
  mounted() {
    this.build(this.$props.config);
    this.$refs.resourcesData.setValuesData(this);
    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id === id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.getNews();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  }
};
</script>

<style>

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  [element="BlogArticleListComponent"] .vdr {
    height: auto !important;
  }

  [element="BlogArticleListComponent"] {
    height: auto !important;
  }

  [data-device='mobile'] .card-article,
  [data-device='tablet'] .card-article{
    width: 100% !important;
    margin-left: 0% !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Lists/Article/ArticleList.vue